/**
 * Created by Omar Alejandro Leonor Avalos on 2017-09-09.
 * Any request executed with this function will set the authorization header and
 * the api url by default
 */
import axios from 'axios';
import { getToken, logout } from '../security';
import { apiUrl } from '../app.config';

axios.interceptors.response
    .use(
    response => response,
    error => {
        const isLoggedIn = getToken() !== null;

        if (!isLoggedIn) { return error; }

        switch (error.response.data.status) {
            case 401:
                alert('La sesión ha caducado. Ingrese sus datos nuevamente.');
                logout();
                break;
            case 403:
                alert('No tiene permisos para acceder a este recurso');
                break;
            case 400:
                break;
            default:
                break;
        }

        return Promise.reject(error);
    });

const request = () => {
    const defaultOptions = {
        headers: {
            Authorization: getToken()
        }
    };

    return {
        get: (url, options = {}) => axios.get(`${apiUrl}${url}`, { ...defaultOptions, ...options }),
        post: (url, data, options = {}) => axios.post(`${apiUrl}${url}`, data, { ...defaultOptions, ...options }),
        put: (url, data, options = {}) => axios.put(`${apiUrl}${url}`, data, { ...defaultOptions, ...options }),
        patch: (url, data, options = {}) => axios.patch(`${apiUrl}${url}`, data, { ...defaultOptions, ...options }),
        delete: (url, data, options = {}) => axios.delete(`${apiUrl}${url}`, { ...data, ...defaultOptions, ...options })
    };
};

export default request;



// WEBPACK FOOTER //
// ./services/request.js